/* eslint-disable @typescript-eslint/unbound-method */
import { Component, Inject, PLATFORM_ID, type OnInit } from '@angular/core';
// eslint-disable-next-line @typescript-eslint/consistent-type-imports
import { UtilService } from '../../shared/services/util.service';
// eslint-disable-next-line @typescript-eslint/consistent-type-imports
import {
  AbstractControl,
  FormBuilder,
  FormGroup,
  ReactiveFormsModule,
  ValidationErrors,
  Validators,
} from '@angular/forms';
import { MatSelectModule } from '@angular/material/select';
import { MatFormFieldModule } from '@angular/material/form-field';
import { MatInputModule } from '@angular/material/input';
// eslint-disable-next-line @typescript-eslint/consistent-type-imports
import { CalendarService } from '../../shared/services/calendar.service';
import { MatRadioModule } from '@angular/material/radio';
import { MatDividerModule } from '@angular/material/divider';
import { addDays, format } from 'date-fns';
import { type MatDatepicker, type MatDatepickerInputEvent, MatDatepickerModule } from '@angular/material/datepicker';
import { provideNativeDateAdapter } from '@angular/material/core';
import { MatButtonModule } from '@angular/material/button';
import { emailValidator } from '../../shared/validators/email.validator';
import { EmailInfo } from '../../shared/models/email-info';
// eslint-disable-next-line @typescript-eslint/consistent-type-imports
import { AccountService } from '../../shared/services/account.service';
import { AccountDetail } from '../../shared/models/account-detail';
import { EmailFormComponent } from '../../shared/components/email-form/email-form.component';
// eslint-disable-next-line @typescript-eslint/consistent-type-imports
import { CmsService } from '../../shared/services/cms.service';
import { isPlatformBrowser, TitleCasePipe } from '@angular/common';
// eslint-disable-next-line @typescript-eslint/consistent-type-imports
import { StorageService } from '../../shared/services/storage.service';
import { StorageEnum } from '../../shared/enums/storage.enum';
import { Address } from '../../shared/models/address';
import { UserProfile } from '../../shared/models/user-profile';
import { postalCodeValidator } from '../../shared/validators/postalCode.validator';
import { States } from '../../shared/enums/states.enum';
// eslint-disable-next-line @typescript-eslint/consistent-type-imports
import { MailingAddressService } from '../../shared/services/mailing-address.service';
import { MailingAddressComponent } from '../../shared/components/mailing-address/mailing-address.component';
import { StopServiceRequest } from '../../shared/models/stop-service-request';
// eslint-disable-next-line @typescript-eslint/consistent-type-imports
import { StartStopMoveService } from '../../shared/services/start-stop-move.service';
import { SuccessData } from '../../shared/models/success-data.model';
// eslint-disable-next-line @typescript-eslint/consistent-type-imports
import { ActivatedRoute, Router } from '@angular/router';
import { Nav } from '../../shared/enums/nav.enum';
// eslint-disable-next-line @typescript-eslint/consistent-type-imports
import { ErrorService } from '../../shared/services/error.service';
// eslint-disable-next-line @typescript-eslint/consistent-type-imports
import { NotificationsService } from '../../shared/services/notifications.service';
import { NotificationType } from '../../shared/enums/notificationtype.enum';
import { NotificationComponent } from '../../shared/components/notification/notification.component';
import { PageHeaderComponent } from '../../shared/components/page-header/page-header.component';
import { PageHeader } from '../../shared/models/page-header.model';
import { SsmStepperComponent } from '../../shared/components/ssm-stepper/ssm-stepper.component';
import { SSMProcessData } from '../../shared/models/start-service';
// eslint-disable-next-line @typescript-eslint/consistent-type-imports
import { SeoService } from '../../shared/services/seo.service';

@Component({
  selector: 'app-stop-service',
  imports: [
    ReactiveFormsModule,
    MatSelectModule,
    MatFormFieldModule,
    MatInputModule,
    MatRadioModule,
    MatDividerModule,
    MatDatepickerModule,
    MatButtonModule,
    EmailFormComponent,
    MailingAddressComponent,
    TitleCasePipe,
    NotificationComponent,
    PageHeaderComponent,
    SsmStepperComponent,
  ],
  templateUrl: './stop-service.component.html',
  styleUrl: './stop-service.component.scss',
  providers: [provideNativeDateAdapter(), TitleCasePipe],
})
export class StopServiceComponent implements OnInit {
  private cleanupZoomListener: () => void = () => {};
  pageReady = false;
  pageLabels: any;
  stopServiceForm: FormGroup;
  aglHolidayList: any;
  today = new Date();
  maxDate: any;
  startDate: any;
  hasEmail = false;
  emailFormData: any = {};
  accountDetail: AccountDetail = new AccountDetail();
  isBrowser = false;
  currentAddress: Address = new Address();
  mailingAddressFormData: any = {};
  loginRes: UserProfile = new UserProfile();
  isMultiAccount: boolean = false;
  addressList: Address[] = [];
  userVerifiedAddress: boolean = false;
  unverifiedAddress: boolean = false;
  unverifiedAddressChanged: boolean = false;
  formErrorMessage?: string = '';
  changeMailingAddress: boolean = false;
  stopReq: StopServiceRequest = new StopServiceRequest();
  successData = new SuccessData();
  saID = '';
  pageHeader = new PageHeader();
  multiSAAddr = {
    address1: '',
    address2: '',
  };

  isMultiSA = false;
  process = 'move';
  step = 1;
  isMove = false;
  ssmData: SSMProcessData = new SSMProcessData();
  pageName = 'Stop Service';

  constructor(
    private readonly utils: UtilService,
    private readonly fb: FormBuilder,
    private readonly cal: CalendarService,
    private readonly account: AccountService,
    private readonly cms: CmsService,
    // eslint-disable-next-line @typescript-eslint/ban-types
    @Inject(PLATFORM_ID) readonly platformId: Object,
    private readonly storage: StorageService,
    private readonly mailingAddressService: MailingAddressService,
    private readonly ssmService: StartStopMoveService,
    private readonly router: Router,
    private readonly error: ErrorService,
    private readonly route: ActivatedRoute,
    private readonly titleP: TitleCasePipe,
    private readonly notifi: NotificationsService,
    private readonly seoS: SeoService,
  ) {
    this.isBrowser = isPlatformBrowser(platformId);
    if (this.isBrowser) {
      this.accountDetail = this.storage.getSession(StorageEnum.AccountDetail);
      this.currentAddress.Address1 = this.accountDetail.Person?.BillingAddress?.Address1;
      this.currentAddress.Address2 = this.accountDetail.Person?.BillingAddress?.Address2;
      this.currentAddress.City = this.accountDetail.Person?.BillingAddress?.City;
      this.currentAddress.Country = this.accountDetail.Person?.BillingAddress?.Country;
      this.currentAddress.PostalCode = this.accountDetail.Person?.BillingAddress?.PostalCode;
      this.currentAddress.State = this.accountDetail.Person?.BillingAddress?.State;
      this.loginRes = this.storage.getSession(StorageEnum.LoginResponse);
      this.ssmData = this.storage.getSession(StorageEnum.SSMData);
    }
    this.stopServiceForm = this.fb.group({
      DateOption: ['', [Validators.required]],
      Date: '',
      Instructions: ['', [Validators.required]],
      Comments: '',
      Reason: ['', [Validators.required]],
    });
    this.cal.getAGLHolidayList().subscribe({
      error: (e) => {
        this.aglHolidayList = '';
      },
      next: (data: any) => {
        this.aglHolidayList = data;
      },
    });
    this.startDate = addDays(this.today, 3);
    this.maxDate = addDays(this.today, 60);
  }

  ngOnInit(): void {
    if (this.router.url.includes('transfer-service')) {
      this.isMove = true;
      if (!this.utils.isNullOrUndefined(this.ssmData)) {
        // if ssmDAta is not null this means user is coming back from later in process and we need to prepopulate form
        this.prepopulateFormData();
      }
    }
    this.cms.getContent('oas-stop-service', 'Stop Service Labels').subscribe((data: any) => {
      this.pageLabels = data;
      this.pageHeader.Message = this.isMove ? this.pageLabels.movePlanHeader : this.pageLabels.planHeader;
      this.seoS.setSeoTags(data.seo);
      this.checkForSaId();

      if (this.isBrowser) {
        this.stopServiceForm.get('DateOption')?.valueChanges.subscribe((val) => {
          const calendarDate = this.stopServiceForm.get('Date');
          // calendar only shows up if user opts to choose a specific date, so conditionally add validators to that field
          if (val === 'choose') {
            calendarDate?.setValidators([Validators.required]);
          } else {
            calendarDate?.clearValidators();
          }
          calendarDate?.updateValueAndValidity();
        });
        // comments only show up if user selects gate code or other for instructions, so conditionally add validators to that field
        this.stopServiceForm.get('Instructions')?.valueChanges.subscribe((val) => {
          const comments = this.stopServiceForm.get('Comments');
          if (val === 'gate' || val === 'other') {
            comments?.setValidators([Validators.required, this.validateComments.bind(this)]);
          } else {
            comments?.clearValidators();
          }
          comments?.updateValueAndValidity();
        });
        this.hasEmail =
          this.accountDetail?.Person?.EmailAddresses?.find((email: EmailInfo) => {
            return email.IsPrimary && email.Type?.toUpperCase() === 'EMAIL';
          })?.IsPrimary ?? false;
        if (!this.hasEmail) {
          this.setupEmailData();
        }
        this.setupMailingAddressData();
        if (this.isMove) {
          // on move we don't show the user the list of reasons and auto set it to moving
          this.stopServiceForm.get('Reason')?.setValue('Moving');
        }
        this.pageReady = true;
      }
      this.utils.hideSpinner();
    });
  }

  onDatepickerOpened(picker: MatDatepicker<Date>): void {
    this.cleanupZoomListener = this.utils.attachDatepickerZoomListener(picker);
  }

  onDatepickerClosed(): void {
    this.cleanupZoomListener();
  }

  dayIsAglHoliday(d: Date): boolean {
    const filteredArray = this.aglHolidayList.filter((holiday: any) => {
      return (
        holiday.Day === d.getDate().toString() &&
        holiday.Month === (d.getMonth() + 1).toString() &&
        holiday.Year === d.getFullYear().toString()
      );
    });
    return filteredArray.length > 0;
  }

  dateFilter = (d: Date | null): boolean => {
    // disable dates that are weekend or AGL holiday
    const innerDate = d ?? new Date();
    return innerDate.getDay() !== 0 && innerDate.getDay() !== 6 && !this.dayIsAglHoliday(innerDate);
  };

  setUpCalendar(): void {
    this.startDate = addDays(this.today, 3);
    this.maxDate = addDays(this.today, 60);
  }

  submitForm(): void {
    this.stopServiceForm.get('DateOption')?.markAsTouched();
  }

  validatePaymentDateOnBlur(e: Event): void {
    // If the current date is between the 1 and the 15th and the requested stop date is after the 20th of the month and before the first of the next month.
    const target = e.target as HTMLInputElement;
    const value = new Date(target.value);
    if (this.today.getDate() >= 1 && this.today.getDate() <= 15) {
      if (value.getDate() > 20) {
        this.notifi.addNotification(
          this.pageLabels.passThroughWarning,
          NotificationType.Prenotification,
          'Stop Service',
        );
      } else {
        this.notifi.clearAllNotifications();
      }
    }
  }

  validatePaymentDateOnCalednarChange(e: MatDatepickerInputEvent<Date>): void {
    // If the current date is between the 1 and the 15th and the requested stop date is after the 20th of the month and before the first of the next month.
    let $date;
    if (e.value === null) {
      $date = new Date();
    } else {
      $date = e.value;
    }
    if (this.today.getDate() >= 1 && this.today.getDate() <= 15) {
      if ($date.getDate() > 20) {
        this.notifi.addNotification(
          this.pageLabels.passThroughWarning,
          NotificationType.Prenotification,
          'Stop Service',
        );
      } else {
        this.notifi.clearAllNotifications();
      }
    }
  }

  validateComments(control: AbstractControl): ValidationErrors | null {
    const value = control.value;
    const commentsPattern = /^[A-Za-z0-9 ]*$/;
    const commentsPatternSpacesOnly = /^[ ]*$/;
    if (!commentsPattern.test(value)) {
      return { invalidCharacters: true };
    }
    if (value) {
      if (value.length > 0 && commentsPatternSpacesOnly.test(value)) {
        return { invalidCharacters: true };
      }
    }
    return null;
  }

  setupEmailData(): void {
    this.emailFormData.showConfirmEmail = true;
    this.emailFormData.formGroup = this.fb.group({
      email: ['', [Validators.required, emailValidator()]],
      emailConfirm: ['', [Validators.required, emailValidator()]],
    });
  }

  setupMailingAddressData(): void {
    if (this.loginRes.TotalNumAccounts && this.loginRes.TotalNumAccounts > 1) {
      this.isMultiAccount = true;
    }
    this.mailingAddressFormData.isMultiAccount = this.isMultiAccount;
    this.mailingAddressFormData.formGroup = this.fb.group({
      address1: ['', [Validators.required]],
      address2: [''],
      city: ['', [Validators.required]],
      postalCode: ['', [Validators.required, postalCodeValidator()]],
      state: [States.GA],
      setDefault: [false],
      addressRadioGroup: [''],
    });

    this.mailingAddressFormData.addressList = this.addressList;
  }

  handleSubmitButtonPress(): void {
    // since there are potentially three forms on this page (new email, new mailing address, stop service), we call them each individually in their own function
    // handlesubmitbuttonpress worries about new email, and then updateMailingAddress handles mailing address, and finally sendStopServiceRequest
    this.formErrorMessage = '';
    this.utils.showSpinner();
    if (!this.hasEmail) {
      // handle new email stuff
      if (this.emailFormData.formGroup.valid) {
        const emailValue = this.emailFormData.formGroup.value.email;

        const personRequest = this.accountDetail?.Person;
        const email = new EmailInfo();
        email.ContactId = '';
        email.Email = emailValue;
        email.IsActive = true;
        email.IsPrimary = true;
        email.Type = 'EMAIL';
        personRequest?.EmailAddresses?.push(email);
        this.account.UpdatePersonContact(personRequest).subscribe({
          error: (e) => {
            this.utils.consoleLog('There was an error adding email on stop service page. Error: ' + e);
            this.utils.hideSpinner();
          },
          next: (data: any) => {
            this.accountDetail.Person = data;
            this.storage.setSession(StorageEnum.AccountDetail, this.accountDetail);
            this.hasEmail = true;
            this.updateMailingAddress();
          },
        });
      } else {
        const errorMessage = this.storage.getSession(StorageEnum.GlobalVars).formError;
        this.emailFormData.formGroup.markAllAsTouched();
        this.showFormErrorLabel(errorMessage);
        this.utils.hideSpinner();
      }
    } else {
      this.updateMailingAddress();
    }
  }

  updateMailingAddress(): void {
    if (this.changeMailingAddress) {
      if (this.mailingAddressFormData.formGroup.valid) {
        if (
          (!this.mailingAddressFormData.formGroup.get('addressRadioGroup').value && !this.unverifiedAddress) ||
          this.unverifiedAddressChanged
        ) {
          this.verifyMailingAddress();
        } else {
          this.mailingAddressService
            .updateMailingAddress(this.mailingAddressFormData.formGroup, this.accountDetail, this.isMultiAccount)
            .subscribe({
              error: (e) => {
                const errorMessage = this.pageLabels.forwardingAddressError;
                this.mailingAddressFormData.formGroup.markAllAsTouched();
                this.showFormErrorLabel(errorMessage);
                this.utils.hideSpinner();
              },
              next: () => {
                this.sendStopServiceRequest();
              },
            });
        }
      } else {
        // Mark all controls as touched to trigger validation messages
        const errorMessage = this.storage.getSession(StorageEnum.GlobalVars).formError;
        this.mailingAddressFormData.formGroup.markAllAsTouched();
        this.showFormErrorLabel(errorMessage);
        this.utils.hideSpinner();
      }
    } else {
      this.sendStopServiceRequest();
    }
  }

  sendStopServiceRequest(): void {
    if (this.stopServiceForm.valid) {
      this.buildStopServiceRequest();
      if (!this.isMove) {
        this.ssmService.stopService(this.stopReq).subscribe({
          error: (e) => {
            this.error.setErrorData('none', this.pageLabels.stopError);
            void this.router.navigateByUrl(Nav.ErrorPage);
          },
          next: () => {
            this.setSuccessData();
            void this.router.navigateByUrl(Nav.StopSuccess);
          },
        });
      } else {
        if (this.ssmData !== null) {
          this.ssmData.StopRequest = this.stopReq;
          this.ssmData.CurrentProcess = 'move';
          if (this.isMultiSA) {
            this.ssmData.StopServiceAddress = (this.multiSAAddr.address1 + ' ' + this.multiSAAddr.address2).trim();
          } else if (
            this.accountDetail.ServiceAddresses !== undefined &&
            this.accountDetail.ServiceAddresses.length > 0
          ) {
            this.ssmData.StopServiceAddress = this.formatSuccessAddress(this.loginRes.Accounts[0].ServiceAddresses[0]);
          } else {
            this.ssmData.StopServiceAddress = '';
          }
          this.storage.setSession(StorageEnum.SSMData, this.ssmData);
        } else {
          const newData = new SSMProcessData();
          newData.StopRequest = this.stopReq;
          newData.CurrentProcess = 'move';
          if (this.isMultiSA) {
            newData.StopServiceAddress = (this.multiSAAddr.address1 + ' ' + this.multiSAAddr.address2).trim();
          } else if (
            this.accountDetail.ServiceAddresses !== undefined &&
            this.accountDetail.ServiceAddresses.length > 0
          ) {
            newData.StopServiceAddress = this.formatSuccessAddress(this.loginRes.Accounts[0].ServiceAddresses[0]);
          } else {
            newData.StopServiceAddress = '';
          }
          this.storage.setSession(StorageEnum.SSMData, newData);
        }
        void this.router.navigateByUrl(Nav.MoveServiceAddress);
      }
    } else {
      // Mark all controls as touched to trigger validation messages
      const errorMessage = this.storage.getSession(StorageEnum.GlobalVars).formError;
      this.stopServiceForm.markAllAsTouched();
      this.showFormErrorLabel(errorMessage);
      this.utils.hideSpinner();
    }
  }

  verifyMailingAddress(): void {
    this.unverifiedAddressChanged = false;
    this.mailingAddressService.mailingAddressVerification(this.mailingAddressFormData.formGroup).subscribe({
      error: (e) => {
        this.addressList.length = 0;
        this.unverifiedAddress = true;
        this.utils.hideSpinner();
      },
      next: (data: any) => {
        if (data) {
          this.addressList.pop();
          this.addressList.pop();
          this.addressList.push(data[0]);
          this.addressList.push(data[1]);
          this.mailingAddressFormData.addressList = this.addressList;
          this.mailingAddressFormData.formGroup.get('addressRadioGroup').setValue(this.addressList[0]);
          this.mailingAddressFormData.formGroup.get('address1')?.setValue(data[0].Address1);
          this.mailingAddressFormData.formGroup.get('address2')?.setValue(data[0].Address2);
          this.mailingAddressFormData.formGroup.get('city')?.setValue(data[0].City);
          this.mailingAddressFormData.formGroup.get('postalCode')?.setValue(data[0].PostalCode);
          this.mailingAddressFormData.formGroup.get('state')?.setValue(data[0].State);
          this.utils.hideSpinner();
        }
      },
    });
  }

  showFormErrorLabel(errorMessage?: string): void {
    this.formErrorMessage = errorMessage;
    if (!this.utils.isNullOrUndefined(this.formErrorMessage) && this.formErrorMessage !== '' && this.formErrorMessage) {
      this.notifi.clearAllNotifications(this.pageName);
      this.notifi.addNotification(this.formErrorMessage, NotificationType.Error, this.pageName);
    }
  }

  unverifiedAddressData(data: boolean): void {
    this.unverifiedAddressChanged = data;
  }

  toggleMailingAddressForm(event?: Event): void {
    if (event instanceof KeyboardEvent && event.code === 'Space') {
      event.preventDefault();
    }
    this.changeMailingAddress = !this.changeMailingAddress;
  }

  buildStopServiceRequest(): void {
    this.stopReq.AccountNumber = this.accountDetail.AccountNumber;
    this.stopReq.DetailedInstructions = this.stopServiceForm.get('Comments')?.value;
    this.stopReq.Email = this.hasEmail
      ? this.accountDetail.Person?.EmailAddresses?.filter((email) => {
          return email.IsPrimary === true;
        })[0].Email
      : this.emailFormData.get('email').value;
    this.stopReq.FirstAvailableText =
      this.stopServiceForm.get('DateOption')?.value === 'first' ? 'First Available' : '';
    this.stopReq.FirstName = this.accountDetail.FirstName;
    if (this.changeMailingAddress) {
      this.stopReq.MailingAddressDifferent = true;
      this.stopReq.ForwardingAddress = new Address();
      this.stopReq.ForwardingAddress.Address1 = this.mailingAddressFormData.formGroup.get('address1').value;
      this.stopReq.ForwardingAddress.Address2 = this.mailingAddressFormData.formGroup.get('address2').value;
      this.stopReq.ForwardingAddress.City = this.mailingAddressFormData.formGroup.get('city').value;
      this.stopReq.ForwardingAddress.PostalCode = this.mailingAddressFormData.formGroup.get('postalCode').value;
      this.stopReq.ForwardingAddress.State = this.mailingAddressFormData.formGroup.get('state').value;
      this.stopReq.ForwardingAddress.Country = 'USA';
    } else {
      this.stopReq.MailingAddressDifferent = false;
      this.stopReq.ForwardingAddress = new Address();
      this.stopReq.ForwardingAddress.Address1 = this.currentAddress.Address1;
      this.stopReq.ForwardingAddress.Address2 = this.currentAddress.Address2;
      this.stopReq.ForwardingAddress.City = this.currentAddress.City;
      this.stopReq.ForwardingAddress.PostalCode = this.currentAddress.PostalCode;
      this.stopReq.ForwardingAddress.State = this.currentAddress.State;
    }
    this.stopReq.ForwardingAddressType = 'Account';
    this.stopReq.InstructionsForMeterStop = this.stopServiceForm.get('Instructions')?.value;
    this.stopReq.LastName = this.accountDetail.LastName;
    this.stopReq.MailingAddressDifferent = this.changeMailingAddress;
    this.stopReq.MailingAddressUseNewAddressOnAllAccounts =
      this.mailingAddressFormData.formGroup.get('setDefault').value;
    this.stopReq.PersonId = this.accountDetail.PersonId;
    this.stopReq.SaId = this.getSaID();
    this.stopReq.ServiceAddressCount = this.accountDetail.ServiceAddressCount;
    this.stopReq.StopDate =
      this.stopServiceForm.get('Date')?.value !== '' ? this.stopServiceForm.get('Date')?.value : new Date();
    this.stopReq.TotalNumAccounts = this.loginRes.TotalNumAccounts;
    this.stopReq.TurnOffReason = this.stopServiceForm.get('Reason')?.value;
  }

  setSuccessData(): void {
    // post notification list set in onInit
    const succLabels = this.cms.getDataFromBuilderReference(this.pageLabels.stopSuccess);

    this.successData.Header = succLabels.header;
    this.successData.Subheader = succLabels.subheaderText;
    this.successData.Details.push({
      Label: succLabels.details[0].detailLabel,
      Value:
        this.multiSAAddr.address1 !== ''
          ? this.multiSAAddr.address1 + ' ' + this.multiSAAddr.address2
          : this.accountDetail.ServiceAddresses !== undefined
            ? this.formatSuccessAddress(this.accountDetail.ServiceAddresses[0])
            : '',
    });
    this.successData.Details.push({
      Label: succLabels.details[1].detailLabel,
      Value:
        this.stopServiceForm.get('DateOption')?.value === 'first'
          ? 'First Available'
          : format(this.stopServiceForm.get('Date')?.value, 'MMMM do, yyyy'),
    });
    this.successData.Details.push({
      Label: succLabels.details[2].detailLabel,
      Value: this.formatSuccessMailingAddress(this.accountDetail.Person?.BillingAddress as Address),
    });
    const ctaLabels = succLabels.ctaList[0];
    this.successData.CTAList.push({
      Label: ctaLabels.ctaLabel,
      Link: ctaLabels.ctaUrl,
      AriaLabel: ctaLabels.ctaAriaLabel,
    });

    this.storage.setSession(StorageEnum.SuccessData, this.successData);
  }

  formatSuccessAddress(address: Address): string {
    const hasLine2 = !this.utils.isNullOrWhitespace(address.Address2);
    let lineOne = '';
    if (hasLine2) {
      lineOne = this.titleP.transform(address.Address1 + ' ' + address.Address2);
    } else {
      lineOne = this.titleP.transform(address.Address1 ?? '');
    }
    let lineTwo = '';
    if (
      !this.utils.isNullOrWhitespace(address.City) &&
      !this.utils.isNullOrWhitespace(address.State) &&
      !this.utils.isNullOrWhitespace(address.PostalCode)
    ) {
      lineTwo = address.City + ', ' + address.State + ' ' + address.PostalCode;
    }
    return lineTwo === '' ? lineOne : lineOne + '<br>' + lineTwo;
  }

  formatSuccessMailingAddress(address: Address): string {
    const hasLine2 = !this.utils.isNullOrWhitespace(address.Address2);
    if (hasLine2) {
      return this.titleP.transform(
        address.Address1 +
          ' ' +
          address.Address2 +
          '<br>' +
          address.City +
          ', ' +
          address.State +
          ' ' +
          address.PostalCode,
      );
    } else {
      return (
        this.titleP.transform(address.Address1) +
        '<br>' +
        this.titleP.transform(address.City) +
        ', ' +
        address.State?.toUpperCase() +
        ' ' +
        address.PostalCode
      );
    }
  }

  checkForSaId(): void {
    const stopAddress = this.storage.getSession(StorageEnum.SelectedSA);
    if (!this.utils.isNullOrUndefined(stopAddress?.SaId)) {
      this.saID = stopAddress.SaId;
      this.isMultiSA = true;
    }
    if (!this.utils.isNullOrUndefined(stopAddress?.Address1)) {
      this.multiSAAddr.address1 = stopAddress.Address1;
    }
    if (!this.utils.isNullOrUndefined(stopAddress?.Address2)) {
      this.multiSAAddr.address2 = stopAddress.Address2;
    }
  }

  getSaID(): string {
    if (this.saID !== '') {
      return this.saID;
    } else {
      return this.accountDetail.ServiceAddresses?.[0].SaId !== undefined
        ? this.accountDetail.ServiceAddresses[0].SaId
        : '';
    }
  }

  prepopulateFormData(): void {
    const storedStopReq = this.ssmData.StopRequest;
    if (storedStopReq?.FirstAvailableText === 'First Available') {
      this.stopServiceForm.get('DateOption')?.setValue('first');
    } else {
      this.stopServiceForm.get('DateOption')?.setValue('choose');
      this.stopServiceForm.get('Date')?.setValue(storedStopReq?.StopDate);
    }
    this.stopServiceForm.get('Instructions')?.setValue(storedStopReq?.InstructionsForMeterStop);
    if (
      this.stopServiceForm.get('Instructions')?.value === 'gate' ||
      this.stopServiceForm.get('Instructions')?.value === 'other'
    ) {
      this.stopServiceForm.get('Comments')?.setValue(storedStopReq?.DetailedInstructions);
    }
    this.stopServiceForm.get('Reason')?.setValue(storedStopReq?.TurnOffReason);
  }
}
